import React, { useContext } from "react";
import { connect } from "react-redux";
import StartARouteCard from "../../../components/Cards/StartARouteCard";
import HeaderBar from "../../../components/Header/HeaderBar";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Outlet } from "react-router-dom";
import ActiveRoutesBaseLayer from "../../../components/Maps/ActiveRoutes/BaseLayer";
import ActiveRouteCards from "./ActiveRoutes/ActiveRouteCards";
import { useState } from "react";
import { useEffect } from "react";
import ActiveRouteDataLayer, {
  ActiveRouteDataContext,
} from "../../../components/Maps/ActiveRoutes/ActiveRouteDataLayer";
import Sidepanel from "../../../components/Maps/ActiveRoutes/ui/sidepanel";
import ActiveRoutesIndexMap from "../../../components/Maps/ActiveRoutes/IndexMap";
import LoadingIcon from "../../../components/Loaders/LoadingIcon";
import primaryLocation from "../../../utils/primaryLocation";

const ActiveRoutesPage = (props) => {
  const queryClient = useQueryClient();

  const refreshData = () => {
    queryClient.invalidateQueries({
      queryKey: [
        "company",
        props.currentUser.currentCompanyId,
        "activeRoutes-new",
      ],
    });
  };

  const companyQuery = useQuery({
    queryKey: [`company/${props.currentUser?.currentCompanyId}`],
    enabled: props.currentUser?.currentCompanyId != null,
  });
  let defaultCenter = { lat: 42.503123, lng: -83.176939 };
  if (companyQuery.data) {
    defaultCenter = primaryLocation(companyQuery.data) ?? defaultCenter;
  }

  return (
    <div className="flex flex-col items-center">
      <HeaderBar title="Active Routes">
        <RefreshTimer refreshData={refreshData} />
      </HeaderBar>

      {companyQuery.isPending ? (
        <LoadingIcon />
      ) : (
        <>
          {/* mapping occurs here */}
          <div className="relative" style={{ width: "100%", height: "680px" }}>
            <ActiveRoutesBaseLayer defaultCenter={defaultCenter}>
              {" "}
              {/* Draws the map */}
              <ActiveRouteDataLayer>
                {" "}
                {/* Supplies the data */}
                <MapIndex /> {/* Draws active crews panel */}
                <Outlet /> {/* Render subroute panels */}
              </ActiveRouteDataLayer>
            </ActiveRoutesBaseLayer>
          </div>

          {/* TODO: long term it would be nice to remove ActiveRouteCards in favor of the above map. Kept for now for users who are used to it. */}
          <ActiveRouteCards />

          <div className="flex items-start w-full px-10">
            <StartARouteCard></StartARouteCard>
          </div>
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { currentUser } = state;
  return { currentUser };
};

export default connect(mapStateToProps)(ActiveRoutesPage);

const MapIndex = () => {
  const { offJobStaff, activeRoutes } = useContext(ActiveRouteDataContext);
  return (
    <Sidepanel>
      <ActiveRoutesIndexMap
        activeRoutes={activeRoutes}
        offJobStaff={offJobStaff}
      />
    </Sidepanel>
  );
};

const RefreshTimer = ({ refreshData }) => {
  let [timeRemaining, setTimeRemaining] = useState(60);

  useEffect(() => {
    if (timeRemaining <= 0) {
      refreshData();
      setTimeRemaining(60);
    }
    setTimeout(() => setTimeRemaining(timeRemaining - 1), 1000);
  });

  return (
    <>
      <span className="text-sm text-gray-600 italic mt-4">
        Next refresh: {timeRemaining}s
      </span>
    </>
  );
};
